import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiHeart,FiShield,FiZap}=FiIcons;

const Footer=()=> {
return (
<motion.footer
initial={{opacity: 0}}
animate={{opacity: 1}}
transition={{duration: 0.6,delay: 0.8}}
className="bg-white/80 backdrop-blur-sm border-t border-emerald-100 py-8"
>
<div className="container mx-auto px-4">
<div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
<div className="text-center md:text-left">
<h3 className="font-semibold text-gray-800 mb-3 flex items-center justify-center md:justify-start space-x-2">
<SafeIcon icon={FiZap} className="text-emerald-500" />
<span>Fast & Reliable</span>
</h3>
<p className="text-gray-600 text-sm">
Lightning-fast URL shortening with instant redirects and reliable uptime.
</p>
</div>

<div className="text-center">
<h3 className="font-semibold text-gray-800 mb-3 flex items-center justify-center space-x-2">
<SafeIcon icon={FiShield} className="text-emerald-500" />
<span>Secure & Private</span>
</h3>
<p className="text-gray-600 text-sm">
Your data is stored locally and never shared. Complete privacy guaranteed.
</p>
</div>

<div className="text-center md:text-right">
<h3 className="font-semibold text-gray-800 mb-3 flex items-center justify-center md:justify-end space-x-2">
<SafeIcon icon={FiHeart} className="text-emerald-500" />
<span>Made with Care</span>
</h3>
<p className="text-gray-600 text-sm">
Crafted with attention to detail for the best user experience.
</p>
</div>
</div>

<div className="border-t border-gray-200 pt-6 text-center">
<p className="text-gray-600 text-sm">
© 2024 NurulQuran Link. Built for the community with ❤️
</p>
<p className="text-gray-500 text-xs mt-2">
link.nurulquran.com - Simple,Fast,Reliable
</p>
<p className="text-gray-400 text-xs mt-1">
Version 1.03
</p>
</div>
</div>
</motion.footer>
);
};

export default Footer;